module.exports = __webpack_public_path__ + "static/media/undraw_new_ideas_jdea.adcddb6a.svg";